var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:[
    'hover:bg-white hover:text-black',
    { active: _vm.active },
    {
      'opacity-50 pointer-events-none touch-none cursor-not-allowed': _vm.disabled
    },
    _vm.item.additionalClass || ''
  ],attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('click', _vm.item)}}},[_c('base-icon',{staticClass:"group-hover:text-sh-secondary-darken-75",attrs:{"name":_vm.item.iconName}}),_c('span',{staticClass:"text-xs group-hover:text-sh-secondary-darken-75 md:block"},[_vm._v("\n    "+_vm._s(_vm.translate(_vm.item.label))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }